import { Component, OnInit } from '@angular/core';
import { RelatorioService } from '@app/services/relatorio.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Subscription } from 'rxjs';
import { ComunicacaoComponentesService } from '@app/services/comunicacao-componentes.service';
import { PrestacaoDeContas, RegistrosPrestacao, TutelaPrestacao } from '@app/models/prestacao-de-contas.model';


@Component({
  selector: 'app-relatorio-prestacao-contas',
  templateUrl: 'relatorio-prestacao-contas.component.html',
})
export class RelPrestacaoContasComponent implements OnInit {
  private subscription: Subscription;

  rel: PrestacaoDeContas = new PrestacaoDeContas();
  processoId: number;
  lstTipoDR: IdDescricao[] = [];
  tipoId?: number = null;

  totalCreditoClienteTutela: number = 0;
  totalHonorarioContratualTutela: number = 0;
  totalRecebidoTutela: number = 0;
  saldoDevedorTutela: number = 0;

  totalCreditoCliente: number = 0;
  totalHonorarioContratual: number = 0;
  totalRecebido: number = 0;
  saldoDevedor: number = 0;

  saldoFinalProcesso: number = 0;
  clienteDevedor: boolean = false;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private consultasService: ConsultasService,
    private relatorioService: RelatorioService,
    private comunicacaoComponentesService: ComunicacaoComponentesService
  ) { }

  ngOnInit(): void {
    this.consultasService.consultar('DR').toPromise().then(data => this.lstTipoDR = data);
    this.subscription = this.comunicacaoComponentesService.obtemClick().subscribe(
      (valor: number) => {
        if(valor === 1){
          this.buscaRelatorio();
          this.subscription.unsubscribe();
        }
      });
}


  buscaRelatorio() {
    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obterTodos();
      });
  }
  
  obterTodos() {
    this.saldoDevedor = 0;
    this.totalRecebido = 0;
    this.totalHonorarioContratual = 0;
    this.totalCreditoCliente = 0;
    this.saldoDevedorTutela = 0;
    this.totalRecebidoTutela = 0;
    this.totalRecebidoTutela = 0;
    this.totalHonorarioContratualTutela = 0;
    this.totalCreditoClienteTutela = 0;

    this.relatorioService.prestacaoContas(this.processoId).toPromise()
      .then((data) => {
        this.rel = data;

        if(data.Tutelas.length > 0)
          this.montaTotaisTutela(data.Tutelas);
        
        if(data.RPVs.length > 0)
          this.montaTotaisRPV(data.RPVs);
          
        this.saldoFinalProcesso = (this.totalHonorarioContratual + this.totalHonorarioContratualTutela) - (this.totalRecebido + this.totalRecebidoTutela);
      },
      erro => {
      });
  }

  montaTotaisTutela(tutelas: TutelaPrestacao[]){
    this.totalCreditoClienteTutela = tutelas.reduce((total, tutela) => total + tutela.CreditoCliente, 0);
    this.totalHonorarioContratualTutela = tutelas.reduce((total, tutela) => total + tutela.HonorarioContratual, 0);
    
    tutelas.forEach(tutela => {
      this.totalRecebidoTutela += tutela.Recebimentos.reduce((total, recebimento) => total + recebimento.Valor, 0);
    });

    this.saldoDevedorTutela = this.totalHonorarioContratualTutela - this.totalRecebidoTutela;
  }

  montaTotaisRPV(rpvs: RegistrosPrestacao[]){
    this.totalCreditoCliente = rpvs.reduce((total, rpv) => total + rpv.CreditoCliente, 0);
    this.totalHonorarioContratual = rpvs.reduce((total, rpv) => total + rpv.HonorarioContratual, 0);
    this.totalRecebido = rpvs.reduce((total, rpv) => total + rpv.TotalRecebido, 0);
    
    this.rel.RPVs.forEach(rpv => {
      rpv.TotalDevedor = rpv.HonorarioContratual - rpv.TotalRecebido;
    })

  }

  btnVoltar() {
    this.router.navigate(['/processos/processo', this.processoId, 'financeiro']);
  }

}

